// Auto-generated user-center i18n extras. Do not edit by hand unless necessary.
export default {
  "ucAccount": {
    "personal": {
      "section": {
        "basicInfo": "基礎信息",
        "professionalInfo": "職業信息"
      },
      "identityType": {
        "mainland": "大陸身份",
        "hkmt": "港澳台身份"
      },
      "form": {
        "idCardType": "證件類型",
        "uploadIdCard": "上傳身份證",
        "uploadCertificate": "上傳證件",
        "realName": "真實姓名",
        "idCardNo": "身份證號碼",
        "certificateNo": "證件號碼",
        "internationalName": "國際用名",
        "phone": "手機號碼",
        "email": "電子郵件",
        "industryType": "行業類型",
        "unitName": "單位名稱",
        "jobPosition": "任職崗位",
        "region": "所在地區"
      },
      "idCard": {
        "mainland": "大陸身份证",
        "hkId": "香港居民身份證",
        "hkMacaoPass": "港澳居民往來內地通行證",
        "taiwanPass": "臺灣居民來往大陸通行證"
      },
      "upload": {
        "frontAlt": "身份證正面",
        "backAlt": "身份證反面",
        "frontLabel": "點擊上傳正面（單個文件大小 不超過2MB）",
        "backLabel": "點擊上傳反面（單個文件大小 不超過2MB）"
      },
      "placeholder": {
        "autoRecognize": "根據上傳自動識別",
        "internationalName": "非必選項，有國際備案需求的用戶建議填寫",
        "pleaseInput": "請輸入",
        "pleaseSelect": "請選擇",
        "regionCascader": "請選擇省/市/区"
      },
      "btn": {
        "reAuth": "重新認證",
        "submit": "提交認證"
      },
      "rule": {
        "selectIdCardType": "請選擇證件類型",
        "uploadFront": "请上傳證件正面",
        "uploadBack": "请上傳證件反面",
        "inputRealName": "請輸入真實姓名",
        "inputIdCardNo": "請輸入證件號碼",
        "inputPhone": "請輸入手機號碼",
        "phoneInvalid": "請輸入正确的手機號碼",
        "inputEmail": "請輸入電子郵件",
        "emailInvalid": "請輸入正确的電子郵件地址",
        "selectRegion": "請選擇所在地區",
        "selectIndustry": "請選擇行業類型"
      },
      "validate": {
        "mainlandId": "請輸入正确的大陸身份證號碼（15位或18位）",
        "hkMacaoPass": "請輸入正确的港澳居民往來內地通行證号码（H/M开头+8位或10位数字）",
        "taiwanPass": "請輸入正确的臺灣居民來往大陸通行證号码（8位数字）",
        "hkId": "請輸入正确的香港居民身份證號碼（如 A123456(0) 或 C668668(E)）"
      },
      "msg": {
        "formIncomplete": "請檢查並完善表單信息",
        "submitting": "提交中...",
        "submitSuccess": "身份認證提交成功"
      }
    },
    "enterprise": {
      "section": {
        "basicInfo": "基礎信息"
      },
      "regionType": {
        "mainland": "大陸身份",
        "hkmt": "港澳台身份"
      },
      "type": {
        "enterprise": "企業",
        "association": "社會組織"
      },
      "form": {
        "authType": "認證類型",
        "businessLicense": "營業執照",
        "registrationCert": "登記證書",
        "enterpriseName": "企業名稱",
        "orgName": "機構名稱",
        "internationalName": "國際名稱",
        "creditCode": "統一社會信用代碼",
        "registrationLicenseNo": "登記執照號",
        "orgCertNo": "機構證書號",
        "orgType": "機構類型",
        "industryType": "行業類型",
        "region": "所在地區",
        "contactPerson": "聯繫人",
        "email": "電子郵件",
        "phone": "手機號碼",
        "smsCode": "驗證碼"
      },
      "upload": {
        "brc": "点击上传商业登记证BRC（单个文件大小不超过2MB）",
        "enterpriseLicense": "点击上传企業營業執照（单个文件大小不超过2MB）",
        "associationCert": "点击上传社會組織登記證書（单个文件大小不超过2MB）",
        "prefix": "点击上传",
        "suffix": "（单个文件大小不超过2MB）",
        "fileEnterpriseLicense": "企業營業執照",
        "fileAssociationCert": "社會組織登記證書"
      },
      "placeholder": {
        "pleaseInputPrefix": "請輸入",
        "internationalName": "非必选项，有国际备案需求的企業建议填写",
        "selectOrgType": "請選擇機構類型",
        "selectIndustry": "請選擇行業類型",
        "selectRegion": "請選擇所在地區",
        "contactPerson": "請輸入聯繫人",
        "email": "請輸入電子郵件",
        "phone": "請輸入手機號碼",
        "smsCode": "請輸入驗證碼"
      },
      "btn": {
        "getCode": "获取驗證碼",
        "countdown": "{n}秒後重新獲取",
        "reAuth": "重新認證",
        "submit": "提交認證",
        "rejectedResubmit": "未通過，重新認證"
      },
      "rule": {
        "uploadLicense": "请上传{label}",
        "inputName": "請輸入{label}",
        "inputCreditCode": "請輸入{label}",
        "creditCodeInvalid": "請輸入正确的{label}",
        "inputContact": "請輸入聯繫人",
        "inputPhone": "請輸入手機號碼",
        "phoneInvalid": "請輸入正确的手機號碼",
        "inputSmsCode": "請輸入驗證碼",
        "inputEmail": "請輸入電子郵件",
        "emailInvalid": "請輸入正确的電子郵件格式",
        "selectRegion": "請選擇所在地區",
        "selectIndustry": "請選擇行業類型",
        "selectOrgType": "請選擇機構類型"
      },
      "msg": {
        "phoneRequired": "请先输入手機號碼",
        "phoneInvalid": "請輸入正确的手機號碼",
        "codeSent": "驗證碼已发送",
        "selectRegionType": "請選擇地区类型",
        "uploadLicense": "请上传營業執照",
        "submitting": "提交中...",
        "submitSuccess": "企業身份認證提交成功",
        "reAuthSuccess": "企業重新認證提交成功"
      }
    },
    "resetPassword": {
      "title": "重置密碼",
      "form": {
        "contactPhone": "企業聯繫人手机号",
        "smsCode": "驗證碼",
        "newPassword": "新密碼",
        "confirmPassword": "確認密碼"
      },
      "placeholder": {
        "loadingPhone": "正在获取企業聯繫人手机号",
        "smsCode": "請輸入驗證碼",
        "newPassword": "8-20位，须含大小写字母和数字",
        "confirmPassword": "请再次输入新密碼"
      },
      "btn": {
        "getCode": "获取驗證碼",
        "countdown": "{n}秒後重新獲取",
        "submit": "提交修改"
      },
      "rule": {
        "phoneMissing": "未获取到企業聯繫人手机号",
        "inputSmsCode": "請輸入驗證碼",
        "smsCodeLen": "驗證碼为6位数字",
        "inputNewPassword": "請輸入新密碼",
        "confirmAgain": "请再次输入密码",
        "passwordMismatch": "两次输入密码不一致"
      },
      "msg": {
        "phoneMissingWarn": "未获取到企業聯繫人手机号",
        "phoneMissingError": "未获取到企業聯繫人手机号",
        "phoneInvalid": "請輸入正确的手機號碼",
        "codeSent": "驗證碼已发送",
        "resetSuccess": "密碼重置成功"
      }
    },
    "memberEdit": {
      "title": "協會會員信息編輯",
      "form": {
        "unitAvatar": "單位標誌",
        "entName": "單位名稱",
        "nature": "企業性质",
        "industryType": "行業類別",
        "mainProducts": "主營產品",
        "introduce": "單位介紹",
        "mainProductsList": "主要產品"
      },
      "upload": {
        "alt": "單位標誌",
        "label": "尺寸比例16:9，建议尺寸384*216px，文件大小不超过10M"
      },
      "placeholder": {
        "entName": "請輸入單位名稱",
        "nature": "請輸入企業性质",
        "industryType": "請輸入行業類別",
        "mainProducts": "請輸入主營產品",
        "introduce": "請輸入單位介紹",
        "mainProductItem": "請輸入主要產品"
      },
      "btn": {
        "add": "添加",
        "confirm": "確認修改"
      },
      "rule": {
        "uploadAvatar": "请上传單位標誌",
        "inputEntName": "請輸入單位名稱",
        "inputNature": "請輸入企業性质",
        "inputIndustry": "請輸入行業類別",
        "inputMainProducts": "請輸入主營產品",
        "inputIntroduce": "請輸入單位介紹",
        "minMainProducts": "请至少添加一个主要產品"
      },
      "msg": {
        "noComma": "主要產品不能包含逗号",
        "duplicateProduct": "已存在相同产品",
        "loadFail": "获取信息失败",
        "submitSuccess": "已提交修改申请，请等待协会管理人员确认",
        "submitFail": "修改失败"
      },
      "confirm": {
        "message": "确认提交修改吗？提交后会自动从协会会员单位中下架，协会管理人员确认后展示。",
        "title": "提示",
        "ok": "确认提交",
        "cancel": "取消"
      }
    },
    "enterpriseAdmin": {
      "btn": {
        "replaceSuperAdmin": "更換超級管理員"
      },
      "dialog": {
        "replaceTitle": "更換超級管理員",
        "confirmReplace": "確認更換"
      },
      "status": {
        "enable": "啟用",
        "disable": "禁用",
        "unknown": "未知"
      },
      "confirm": {
        "toggleStatus": "确定要{statusText}管理员\"{name}\"吗？",
        "title": "提示",
        "ok": "确定",
        "cancel": "取消"
      },
      "msg": {
        "inviteSuccess": "發送邀請成功",
        "replaceSuccess": "更換超級管理員成功"
      }
    }
  },
  "ucJoinChannel": {
    "title": "加入渠道",
    "form": {
      "channelCode": "渠道碼"
    },
    "placeholder": {
      "channelCode": "請輸入渠道碼，享受数字备案优惠"
    },
    "btn": {
      "join": "加入渠道"
    },
    "fallback": {
      "unnamedChannel": "未命名渠道"
    },
    "msg": {
      "selectChannel": "請選擇渠道",
      "inputChannelCode": "請輸入渠道碼",
      "joinSuccess": "加入渠道成功"
    }
  },
  "ucOrder": {
    "filter": {
      "all": "全部",
      "orderTime": "訂單時間"
    },
    "date": {
      "rangeSeparator": "至",
      "startPlaceholder": "開始日期",
      "endPlaceholder": "結束日期"
    },
    "btn": {
      "myInvoice": "我的發票",
      "detail": "詳情"
    },
    "table": {
      "orderNo": "訂單編號",
      "orderType": "訂單類型",
      "orderAmount": "訂單金額",
      "payableAmount": "實際支付金額",
      "orderTime": "下單時間",
      "payMethod": "付款方式",
      "payTime": "付款時間",
      "payStatus": "支付狀態",
      "operation": "操作"
    },
    "detail": {
      "title": "订单詳情",
      "orderNo": "訂單編號",
      "orderType": "訂單類型",
      "orderAmount": "訂單金額",
      "payableAmount": "實際支付金額",
      "payStatus": "支付狀態",
      "payMethod": "付款方式",
      "orderTime": "下單時間",
      "payTime": "付款時間",
      "goodsType": "商品類型",
      "goodsName": "商品名稱",
      "refundAmount": "退款金額",
      "remark": "備註"
    },
    "payMethod": {
      "zero": "零元支付",
      "alipay": "支付寶",
      "wechat": "微信支付"
    },
    "payStatus": {
      "pending": "待支付",
      "success": "支付成功",
      "cancelled": "已取消",
      "refunded": "已退款"
    }
  },
  "ucInvoice": {
    "filter": {
      "all": "全部",
      "invoiceStatus": "發票狀態",
      "orderNo": "訂單號"
    },
    "placeholder": {
      "statusAll": "全部",
      "orderNo": "請輸入訂單號"
    },
    "status": {
      "all": "全部",
      "invoiced": "已開票",
      "pending": "待開票"
    },
    "btn": {
      "confirmInvoice": "確認開票",
      "confirmInvoiceWithCount": "確認開票（{n}）",
      "detail": "詳情",
      "invoice": "開票"
    },
    "table": {
      "orderNo": "訂單編號",
      "orderType": "訂單類型",
      "orderTime": "下單時間",
      "productName": "商品名稱",
      "orderAmount": "訂單金額(元)",
      "payAmount": "支付金额(元)",
      "payTime": "付款時間",
      "invoiceStatus": "發票狀態",
      "operation": "操作"
    },
    "detail": {
      "title": "订单詳情",
      "orderNo": "訂單編號",
      "orderType": "訂單類型",
      "invoiceStatus": "發票狀態",
      "orderAmount": "訂單金額(元)",
      "payAmount": "支付金额(元)",
      "productName": "商品名稱",
      "orderTime": "下單時間",
      "payTime": "付款時間",
      "remark": "備註"
    },
    "msg": {
      "selectPending": "請選擇待開票订单"
    },
    "issue": {
      "title": "開發票",
      "section": {
        "headerInfo": "發票抬頭信息"
      },
      "btn": {
        "addHeader": "新增發票抬頭",
        "setDefault": "设置默认",
        "delete": "删除",
        "confirmInvoice": "確認開票",
        "confirm": "确认"
      },
      "empty": {
        "noHeader": "暂无发票抬头，请先新增"
      },
      "badge": {
        "defaultHeader": "默认抬头"
      },
      "label": {
        "titleType": "抬头类型：",
        "taxNumber": "税号：",
        "companyAddress": "单位地址：",
        "phone": "电话：",
        "bankName": "开户银行：",
        "bankAccount": "银行账户：",
        "enterpriseTitle": "企業抬头",
        "personalTitle": "个人抬头",
        "receiveEmail": "接收邮箱",
        "email": "邮箱"
      },
      "stats": {
        "selectedOrders": "已选订单：",
        "orderUnit": "笔",
        "orderNo": "訂單編號：",
        "amount": "開票金额：",
        "yuan": "元"
      },
      "headerDialog": {
        "addTitle": "新增發票抬頭",
        "editTitle": "编辑发票抬头"
      },
      "headerForm": {
        "titleType": "抬头类型",
        "taxNumber": "税号",
        "companyAddress": "单位地址",
        "phone": "电话",
        "bankName": "开户银行",
        "bankAccount": "银行账户"
      },
      "placeholder": {
        "pleaseInput": "請輸入"
      },
      "rule": {
        "selectTitleType": "請選擇抬头类型",
        "inputEnterpriseTitle": "請輸入企業抬头",
        "inputPersonalTitle": "請輸入个人抬头",
        "inputReceiveEmail": "請輸入接收邮箱",
        "inputEmail": "請輸入邮箱",
        "emailInvalid": "請輸入正确的邮箱格式",
        "inputTaxNumber": "請輸入税号",
        "inputCompanyAddress": "請輸入单位地址",
        "inputPhone": "請輸入电话",
        "inputBankName": "請輸入开户银行",
        "inputBankAccount": "請輸入银行账户"
      },
      "msg": {
        "selectOrAddHeader": "請選擇或新增發票抬頭",
        "selectOrders": "請選擇需要開票的订单",
        "invalidOrderNo": "訂單編號无效",
        "invoiceSuccess": "開票成功",
        "batchInvoiceSuccess": "批量開票成功",
        "invoiceFail": "開票失败",
        "setDefaultSuccess": "已设为默认发票抬头",
        "deleteSuccess": "删除成功",
        "loginRequired": "请先登录",
        "editSuccess": "编辑成功",
        "addSuccess": "新增成功"
      },
      "confirm": {
        "deleteHeader": "确定删除该发票抬头吗？",
        "title": "提示",
        "ok": "确定"
      },
      "titleTypeOption": {
        "personal": "个人",
        "enterprise": "企業"
      }
    },
    "billDetail": {
      "title": "发票詳情",
      "status": {
        "current": "当前開票状态",
        "unknown": "未知状态"
      },
      "btn": {
        "previewInvoice": "预览发票",
        "preview": "预览",
        "copyLink": "复制链接"
      },
      "section": {
        "buyer": "购方信息",
        "invoice": "发票信息"
      },
      "buyer": {
        "name": "购方名称",
        "taxNo": "购方税号",
        "phone": "交付电话",
        "address": "购方地址",
        "bankName": "开户银行",
        "bankAccount": "银行账号"
      },
      "invoice": {
        "type": "发票种类",
        "redBlueFlag": "红蓝标志",
        "drawer": "開票人",
        "codeNo": "代码/号码",
        "digitNo": "数电发票号码",
        "digitAccount": "数电账号",
        "createDate": "创建日期",
        "invoiceDate": "開票日期",
        "issueMethod": "開票方式",
        "issueMethodValue": "接口开具"
      },
      "flag": {
        "blue": "蓝票",
        "red": "红票"
      },
      "typeCode": {
        "85": "數電紙質發票(增值稅專用發票)",
        "86": "數電紙質發票(普通發票)",
        "87": "數電紙質發票(機動車銷售統一發票)",
        "88": "數電紙質發票(二手車銷售統一發票)",
        "01": "數電票(增值稅專用發票)",
        "02": "數電票(普通發票)",
        "004": "增值稅專用發票",
        "005": "機動車銷售統一發票",
        "006": "二手車銷售統一發票",
        "007": "增值稅普通發票",
        "025": "增值稅普通發票(卷式)",
        "026": "增值稅電子普通發票",
        "028": "增值稅電子專用發票"
      },
      "pdf": {
        "name": "电子发票 PDF 源文件",
        "hint": "可直接在线预览或复制链接下载"
      },
      "empty": {
        "noBill": "暂无票据信息"
      },
      "msg": {
        "noPdfUrl": "暂无 PDF 地址",
        "copied": "已添加到剪贴板",
        "copyFail": "复制失败，请手动复制",
        "invalidOrderNo": "訂單編號无效",
        "noBillWarn": "暂无票据信息",
        "queryFail": "查詢票据失败"
      }
    }
  },
  "ucMessage": {
    "actions": {
      "markAllRead": "一鍵標記已讀"
    },
    "loading": "加載中...",
    "status": {
      "unread": "未讀",
      "read": "已讀",
      "starred": "已加星標"
    },
    "confirm": {
      "markAllRead": "确定要将所有\"{messageTypeName}\"类型的未讀消息标记为已讀吗？",
      "title": "确认操作",
      "ok": "确定",
      "cancel": "取消"
    },
    "fallback": {
      "systemMessage": "系統消息"
    },
    "toast": {
      "markSuccess": "標記成功"
    },
    "tabs": {
      "system": "系統消息",
      "business": "業務消息",
      "activity": "活動消息"
    }
  },
  "ucApproval": {
    "tabs": {
      "pending": "待我授權",
      "myInitiated": "我的發起"
    },
    "columns": {
      "applicant": "发起主体用户",
      "approver": "接受主体用户",
      "businessType": "业务类型",
      "status": "状态",
      "createTime": "发起时间",
      "operateTime": "操作时间",
      "actions": "操作"
    },
    "actions": {
      "authorize": "授權",
      "detail": "詳情"
    },
    "mobile": {
      "applicant": "发起主体：",
      "approver": "接受主体：",
      "createTime": "发起时间：",
      "operateTime": "操作时间："
    },
    "status": {
      "unknown": "未知",
      "pending": "待授權",
      "approved": "已通過",
      "rejected": "已驳回"
    },
    "toast": {
      "loadMyInitiatedFail": "加载我的發起列表失败",
      "approved": "授權通過"
    },
    "detail": {
      "title": "授權詳情",
      "ok": "确定",
      "applicant": "发起主体用户：",
      "approver": "接受主体用户：",
      "businessType": "业务类型：",
      "status": "状态：",
      "createTime": "发起时间：",
      "operateTime": "操作时间："
    },
    "confirm": {
      "message": "确定要授權该申请吗？",
      "title": "授權确认",
      "pass": "通過",
      "reject": "拒絕",
      "applicant": "发起主体用户：",
      "businessType": "业务类型："
    }
  },
  "ucConsultation": {
    "tabs": {
      "awaitingAnswer": "諮詢待解答",
      "inConsultation": "諮詢中",
      "completed": "諮詢結束"
    },
    "search": {
      "placeholder": "請輸入"
    },
    "columns": {
      "index": "序號",
      "title": "標題",
      "type": "諮詢事務類型",
      "industry": "諮詢行業",
      "area": "涉及地區",
      "submitTime": "提交時間",
      "actions": "操作"
    },
    "actions": {
      "detail": "詳情"
    },
    "toast": {
      "loadDetailFail": "加载咨询詳情失败"
    },
    "detail": {
      "back": "返回",
      "labels": {
        "title": "標題：",
        "type": "諮詢事務類型：",
        "industry": "諮詢行業：",
        "area": "涉及区域：",
        "content": "内容：",
        "attachment": "附件：",
        "expert": "分配专家："
      },
      "attachmentFallback": "附件",
      "preview": "预览",
      "download": "下载",
      "alt": {
        "customer": "客户",
        "replier": "回复方"
      },
      "chatEmpty": "暂无聊天记录",
      "placeholder": {
        "reply": "請輸入回复内容",
        "followUp": "請輸入要追加的咨询内容"
      },
      "finish": "結束諮詢",
      "replyBtn": {
        "sendReply": "發送回復",
        "append": "追加諮詢"
      },
      "endedTip": "咨询已结束",
      "toast": {
        "needContent": "請輸入内容",
        "abnormal": "咨询信息异常",
        "sendSuccess": "發送成功",
        "sendFail": "发送失败",
        "finished": "已結束諮詢",
        "operateFail": "操作失败"
      },
      "confirm": {
        "finish": "确定结束本次咨询？结束后将无法继续发送消息。",
        "tip": "提示"
      }
    }
  },
  "ucActivity": {
    "title": "我參與的活動",
    "search": {
      "placeholder": "請輸入查詢内容"
    },
    "date": {
      "rangeSeparator": "至",
      "startPlaceholder": "开始月份",
      "endPlaceholder": "结束月份",
      "format": "YYYY年M月"
    },
    "actions": {
      "query": "查詢",
      "reset": "重置",
      "viewDetail": "查看詳情"
    },
    "card": {
      "activityId": "活动ID:"
    },
    "empty": "暫無參與的活動",
    "loading": "加載中..."
  },
  "ucCollection": {
    "tabs": {
      "ip": "收藏IP",
      "supplyChain": "收藏供應鏈"
    },
    "actions": {
      "goTradingCenter": "前往授權交易中心"
    },
    "empty": {
      "supplyChain": "暫無收藏的供應鏈",
      "ip": "暫無收藏的IP"
    }
  }
}
